import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Layout from "./../../layouts/Main";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  showBid,
  cancelBid,
  updateBid,
} from "./../../store/actions/BidActions";
import { getProductById } from "./../../store/actions/ProductActions";
import { getMoqById } from "./../../store/actions/MoqActions";
import { toast } from "react-toastify";
import { Tooltip } from 'react-tooltip';
import RecommendedProducts from "./../../components/RecommendedProducts";
import ContentLoader from "react-content-loader";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Edit(props) {
  const {
    bids: { bid },
    products: { product },
    moqs: { moq },
  } = props;

  const [img, setImg] = useState(product !== null ? product?.images[0] : "");

  const [loading, setLoading] = useState(false);

  const [quantity, setQuantity] = useState(0);

  const [shipping, setShipping] = useState("AIR");

  const [bidAttributes, setBidAttributes] = useState([
    { size_id: 0, quantity: 0, color_id: 0 },
  ]);

  const params = useParams();
  const scrollContainer = useRef(null);

  // Functions
  const handleAddClick = () => {
    setBidAttributes([
      ...bidAttributes,
      { size_id: 0, quantity: 0, color_id: 0 },
    ]);
  };

  const handleRemoveClick = (index) => {
    let list = [...bidAttributes];

    list.splice(index, 1);

    setBidAttributes(list);
  };

  const handleInputChange = (e, index, color_id = false) => {
    const { name, value } = e.target;

    let attributes = [...bidAttributes];

    if (color_id === true) {
      attributes[index]["color_id"] = parseInt(value);
    } else {
      attributes[index][name] = parseInt(value);
    }

    if (
      product?.readable_sizes.length === 1 &&
      (product?.readable_sizes[0]?.label === "None" ||
        product?.readable_sizes[0]?.label === "none")
    ) {
      attributes[index]["size_id"] = product?.readable_sizes[0]?.id;
    }

    setBidAttributes(attributes);
  };

  useEffect(() => {
    async function fetchBid(id) {
      let response = await props.showBid(id);

      // console.log(response)

      if (response && response?.length > 0 && response[0]?.product[0]?.id) {
        await props.getProductById(response[0]?.product[0]?.id);
      }
    }

    fetchBid(params?.id);
  }, []);

  useEffect(() => {
    if (product !== null && product?.images[0]) {
      setImg(product?.images[0]);
    }
  }, [product]);

  useEffect(() => {
    if (bid && bid?.bid_attributes && bid?.bid_attributes?.length > 0) {
      bid?.bid_attributes.forEach((attr) => {
        delete attr?.sizes;

        delete attr?.colors;
      });

      setBidAttributes(bid?.bid_attributes);
    }

    if (bid) {
      setQuantity(bid?.quantity);

      setShipping(bid?.shipping);
    }

    if (bid?.moq && bid?.moq?.length > 0) {
      async function fetchMOQ(id) {
        try {
          await props.getMoqById(id);
        } catch (error) {
          console.log(error);
        }
      }
      fetchMOQ(bid?.moq[0]?.id);
    }
  }, [bid]);

  const updateBid = async () => {
    try {
      let data = [],
        qty = 0,
        values = {};

      values.quantity = quantity;

      if (moq?.below_moq_price && moq?.below_moq_price === 0 && (quantity === 0 || quantity < bid?.moq[0]?.min_quantity)) {
        return toast.warning(
          `Please provided the required quantity which must be ${bid?.moq[0]?.min_quantity} or above`,
          {
            position: toast.POSITION.BOTTOM_CENTER,

            autoClose: 10000,
          }
        );
      }

      for (let i = 0; i < bidAttributes.length; i++) {
        if (bidAttributes[i].size_id === 0) {
          return toast.warning(
            "Please select appropriate size in order attributes!",
            {
              position: toast.POSITION.BOTTOM_CENTER,

              autoClose: 10000,
            }
          );
        }

        if (bidAttributes[i].color_id === 0) {
          return toast.warning(
            "Please select appropriate color in order attributes!",
            {
              position: toast.POSITION.BOTTOM_CENTER,

              autoClose: 10000,
            }
          );
        }

        if (bidAttributes[i].quantity === 0) {
          return toast.warning(
            "Quantity on order attributes should be more than zero!",
            {
              position: toast.POSITION.BOTTOM_CENTER,

              autoClose: 10000,
            }
          );
        }
      }

      if (
        bidAttributes.length > 0 &&
        bidAttributes[0].size_id !== 0 &&
        bidAttributes[0].quantity !== 0 &&
        bidAttributes[0].color_id !== 0
      ) {
        data = bidAttributes;

        bidAttributes.forEach((attribute) => {
          qty = qty + attribute.quantity;
        });

        if (parseInt(values.quantity) !== qty) {
          toast.warning(
            "Sum of quantity on order attributes must be same as MOQ quantity provided!",
            {
              position: toast.POSITION.BOTTOM_CENTER,

              autoClose: 10000,
            }
          );

          return null;
        }
      }

      values.bid_attributes = data;

      values.shipping = shipping;

      setLoading(true);

      const result = await props.updateBid(bid?.id, values);

      if (result) {
        toast.success("Order Updated Successfully !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });

        setBidAttributes([{ size_id: 0, quantity: 0, color_id: 0 }]);

        setQuantity(0);

        setLoading(false);

        setTimeout(() => {
          return (window.location.href = `/items/${bid?.id}`);
        }, 3000);
      }
    } catch (error) {
      setLoading(false);

      if (
        error &&
        error?.response?.data &&
        error?.response?.data !== undefined &&
        error?.response?.data?.message !== undefined
      ) {
        return toast.error(`${error.response.data.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }

      toast.error("Please try again later !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  function findBelowMOQPriceMinMax(arr) {
    let min = 0;

    let max = 0;

    if (arr === undefined) {
      return { min, max };
    } else {
      min = arr && arr?.length > 0 ? arr[0].below_moq_price || 0 : 0;

      max = arr && arr?.length > 0 ? arr[0].below_moq_price || 0 : 0;
    }

    if (arr && arr?.length > 0) {
      for (let i = 1, len = arr.length; i < len; i++) {
        let v = arr[i].below_moq_price || 0;
        min = v < min ? v : min;
        max = v > max ? v : max;
      }
    }

    return [min, max];
  }

  function getBelowMOQPrice(value) {
    let varying_sizes = value?.product[0]?.varying_sizes || 0;
    if (varying_sizes === 1) {
      let data = findBelowMOQPriceMinMax(value?.moq_attributes);
      if (data?.length === 2 && data[0] === data[1]) {
        return data[0]?.toLocaleString();
      } else {
        return `${data[0]?.toLocaleString()} - ${data[1]?.toLocaleString()}`;
      }
    } else {
      return value?.below_moq_price?.toLocaleString() || 0;
    }
  }

  function findMinMax(arr) {
    let min = arr ? arr[0].price : 0,
      max = arr ? arr[0].price : 0,
      length = arr ? arr.length : 0;

    for (let i = 1, len = length; i < len; i++) {
      let v = arr[i].price;
      min = v < min ? v : min;
      max = v > max ? v : max;
    }

    return { min, max };
  }

  const toTitleCase = (str) =>
    str
      ?.toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const renderShippingFees = (moq, product, feeType) => {
    // helper to capitalize each word
    const toTitleCase = (str) =>
      str
        ?.toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());

    if (
      moq?.product[0]?.varying_sizes === 1 &&
      product?.readable_sizes?.length > 0 &&
      moq?.moq_attributes.length > 0
    ) {
      // If all fees are null/0 → show a single N/A
      if (moq.moq_attributes.every(attr => !attr?.[feeType])) {
        return <p className="text-xs text-[#5B5B5B]">N/A</p>;
      }

      // Otherwise, render only valid fees
      return moq.moq_attributes.map((attr, i) =>
        attr?.[feeType] ? (
          <p key={i} className="text-xs text-[#5B5B5B]">
            {toTitleCase(
              product?.readable_sizes?.find(size => size?.id === attr?.size_id)
                ?.label
            )}{" "}
            KES {attr[feeType].toLocaleString()} each
          </p>
        ) : null
      );
    }

    // Fallback: single attribute check
    return (
      <p className="text-xs text-[#5B5B5B]">
        {moq?.moq_attributes[0]?.[feeType]
          ? `KES ${moq.moq_attributes[0][feeType]} each`
          : "N/A"}
      </p>
    );
  };

  let below_moq_price = 0;

  if (moq) {
    below_moq_price = getBelowMOQPrice(moq);
  }

  const scroll = (direction) => {
    const { current } = scrollContainer;
    if (!current) return;
    if (direction === "left") {
      current.scrollBy({ left: -300, behavior: "smooth" });
    } else {
      current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const ScrollButton = ({ direction = "right", onClick }) => {
    const isLeft = direction === "left";

    return (
      <button
        onClick={onClick}
        className={`
          absolute top-1/2 z-20 bg-tangerine text-white
          p-1.5 md:p-2 rounded-full
          transform -translate-y-1/2
          ${isLeft
            ? "left-1 md:left-[-12px] -translate-x-1/2"  // mobile inside, desktop outside
            : "right-1 md:right-[-12px] translate-x-1/2"}
          hover:scale-110 transition-transform duration-200
          shadow-md
        `}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="h-4 w-4 md:h-5 md:w-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d={isLeft
              ? "M15.75 19.5 8.25 12l7.5-7.5"
              : "m8.25 4.5 7.5 7.5-7.5 7.5"}
          />
        </svg>
      </button>
    );
  };

  const BlockLoader = ({
    height = 300,
    width = "100%",
    radius = 8,
    uniqueKey = "unique",
  }) => (
    <ContentLoader
      uniqueKey={uniqueKey}
      speed={2}
      width={width}
      height={height}
      backgroundColor="#ECEBEB"
      foregroundColor="#b0b0b0"
    >
      <rect
        x="0"
        y="0"
        rx={`${radius}`}
        ry={`${radius}`}
        width="100%"
        height={`${height}`}
      />
    </ContentLoader>
  );

  return (
    <Layout>
      {(!bid || !moq) && <BlockLoader height={"80vh"} radius={4} />}
      {bid && moq && (
        <>
          <div className="w-full grid grid-cols-1 md:grid-cols-[30fr_35fr_35fr] gap-0 md:gap-8">
            <div className="col-span-full w-full md:col-span-1">
              <h1 className="text-2xl text-gray-700 dark:text-white font-bold">
                {product !== null &&
                  moq !== null &&
                  moq?.product &&
                  toTitleCase(moq?.product[0]?.name)}
              </h1>
              {product !== null &&
                moq?.moq_attributes &&
                moq?.product &&
                moq?.product[0] &&
                moq?.product[0]?.varying_sizes === 1 ? (
                <h2 className="text-2xl font-bold text-tangerine">
                  KES{" "}
                  {findMinMax(moq?.moq_attributes)?.min
                    ? findMinMax(moq?.moq_attributes)?.min.toLocaleString()
                    : 0}{" "}
                  -{" "}
                  {findMinMax(moq?.moq_attributes)?.max
                    ? findMinMax(moq?.moq_attributes)?.max.toLocaleString()
                    : 0}
                </h2>
              ) : (
                <h2 className="text-2xl font-bold text-tangerine">
                  KES {moq?.price ? moq?.price.toLocaleString() : 0}
                </h2>
              )}
            </div>
            <div className="flex flex-col col-span-full w-full md:col-span-1 md:px-4">
              {moq?.min_quantity > 1 && below_moq_price !== 0 && below_moq_price !== "0" && (
                <>
                  <p
                    className="text-md text-tangerine font-bold text-sm inline-flex items-center"
                  >
                    Below MOQ Price: KES {getBelowMOQPrice(moq)}
                    <svg xmlns="http://www.w3.org/2000/svg"
                      fill="rgb(141, 198, 63)"
                      viewBox="0 0 24 24"
                      strokeWidth="2.5"
                      stroke="white"
                      className="w-5 h-5"
                      data-tooltip-id="below-moq-tooltip"
                      data-tooltip-content={`Price per piece if your quantity is below ${moq?.min_quantity} items`}
                      data-tooltip-placement="right"
                      style={{ cursor: "pointer" }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                      />
                    </svg>
                  </p>
                  <Tooltip id="below-moq-tooltip" />
                </>
              )}

              <p className="text-md text-gray-600 dark:text-white font-bold text-sm">
                MOQ Per Person: {moq?.min_quantity} items / bundle
              </p>

              <p className="text-md text-gray-600 dark:text-white font-bold text-sm">
                MOQ Number: {moq?.moq_number}
              </p>

              <p className="text-md text-gray-600 dark:text-white font-bold tex</p>t-sm">
                MOQ Status:{" "}
                {moq?.status === 0 ||
                  moq?.moq_order_status !== "not placed" ? (
                  <span className="text-red-500">Not Active</span>
                ) : (
                  "Active"
                )}
              </p>
            </div>

            <div className="md:col-span-1 flex flex-col">
              <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center w-full space-y-3 md:space-y-0">
                <div className="flex flex-col w-full">
                  <p className="text-md text-gray-600 dark:text-gray-300 font-bold text-sm">
                    Supplier MOQ: {moq?.quantity} items
                  </p>

                  <p className="text-md text-gray-600 dark:text-gray-300 font-bold text-sm">
                    Group buy orders so far: {moq?.total_bid_quantity}
                  </p>
                  <p className="text-md text-tangerine font-bold text-sm">{`${moq?.percentage_full}% Sold`}</p>
                </div>
              </div>
            </div>


            {/* Left side: Image + Thumbnails */}
            <div className="h-full w-full flex flex-col col-span-full md:col-span-1">
              <div className="w-full mb-3 mt-3">
                {/* Main Image */}
                <div className="w-full h-[500px] rounded-lg overflow-hidden relative flex items-center justify-center mb-3">
                  {/* Blurred background */}
                  <div
                    className="absolute inset-0 bg-cover bg-center filter blur-lg scale-110"
                    style={{ backgroundImage: `url(${img || "https://via.placeholder.com/300"})` }}
                  ></div>

                  {/* Main image */}
                  <LazyLoadImage
                    className="max-w-full max-h-full object-contain relative z-10"
                    src={img || "https://via.placeholder.com/300"}
                    alt={"product"}
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/300";
                    }}
                  />
                </div>

                <div className="relative w-full">
                  <ScrollButton direction="left" onClick={() => scroll("left")} />
                  {moq !== null &&
                    moq?.product &&
                    moq?.product[0]?.images !== undefined &&
                    moq?.product[0]?.images.length > 1 && (
                      <div
                        ref={scrollContainer}
                        className="relative max-w-full overflow-x-auto overflow-y-visible whitespace-nowrap w-full space-x-4 md:mt-4 scrollbar-hide px-4"
                      >
                        {moq?.product &&
                          moq?.product[0]?.images.map((image, i) => (
                            <div
                              key={i}
                              className={`
                              relative inline-block bg-white w-[96px] h-[96px] rounded-md cursor-pointer overflow-hidden transition-all duration-200 ease-out
                              ${img === image
                                  ? "ring-2 ring-litudian-orange scale-[1.03] shadow-md"
                                  : "hover:ring-2 hover:ring-gray-300"}
                            `}
                              onClick={() =>
                                setImg(image || "https://via.placeholder.com/300")
                              }
                            >
                              {/* Blurred background */}
                              <div
                                className="absolute inset-0 bg-cover bg-center blur-lg scale-110 z-0"
                                style={{ backgroundImage: `url(${image || "https://via.placeholder.com/300"})` }}
                              ></div>

                              {/* Foreground image */}
                              <LazyLoadImage
                                className="relative z-10 h-[96px] object-contain w-[96px]"
                                src={image || "https://via.placeholder.com/300"}
                                alt="product"
                                onError={(e) => {
                                  e.target.src = "https://via.placeholder.com/300";
                                }}
                              />
                            </div>
                          ))}
                      </div>
                    )}
                  <ScrollButton direction="right" onClick={() => scroll("right")} />
                </div>
              </div>
            </div>

            <div className="col-span-full md:col-span-2 flex flex-col bg-[#fff] dark:bg-[#252525] border-[#5B5B5B] rounded mb-10 md:px-4">
              <div className="grid grid-cols-1 md:grid-cols-6 md:gap-8 py-4">
                <div className="flex flex-col col-span-3 space-y-5 px-4 md:px-0">
                  <h2 className="font-bold text-lg leading-5 text-litudian-orange">Description</h2>
                  <div
                    className="product-description text-gray-600 dark:text-gray-300 w-full h-full text-justify"
                    style={{ marginTop: "10px" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        product !== null && moq !== null && moq?.product
                          ? moq?.product[0]?.description
                          : "",
                    }}
                  />
                </div>
                <div className="flex flex-col col-span-3 space-y-3">
                  <h3 className="block md:block font-bold text-lg leading-5 text-litudian-orange">Edit Your Order #{bid.bid_number}</h3>
                  <div className="w-full flex flex-col max-h-full md:max-h-[500px] 2xl:max-h-full overflow-y-auto bg-[#F9F9F9] dark:bg-gray-800 px-4 md:px-8 py-8 md:py-2 rounded shadow-md scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 scrollbar-thumb-rounded-full">
                    <form
                      className="flex flex-col space-y-3 make-order-1"
                      onSubmit={(e) => {
                        e.preventDefault();

                        updateBid();
                      }}
                    >
                      <h2 className="text-[#A68F69] dark:text-gray-300 font-bold text-lg">Total Quantity</h2>

                      <input
                        className="focus:outline-none border border-[#A68F69] box-border px-2 py-3 text-base font-bold rounded focus:ring-2 ring-[#A68F69] w-full"
                        type={"number"}
                        min={below_moq_price > 0 || below_moq_price.length > 0 ? 1 : bid?.moq[0]?.min_quantity}
                        name="quantity"
                        onChange={(e) => setQuantity(e.target.value)}
                        value={quantity}
                        disabled={bid?.status === 1}
                      />

                      <h2 className="text-[#A68F69] dark:text-gray-300 font-bold text-lg">
                        Order Attributes
                      </h2>

                      {bidAttributes.map((x, i) => (
                        <div
                          key={i}
                          className="grid grid-col-1 gap-2 mb-5 space-y-3 md:space-y-0"
                        >
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-y-3 md:gap-y-0 md:gap-x-3">
                            <div
                              className={`${product?.readable_sizes &&
                                product?.readable_sizes.length === 1 &&
                                (product?.readable_sizes[0]?.label === "None" ||
                                  product?.readable_sizes[0]?.label === "none")
                                ? "hidden"
                                : "block"
                                } space-y-2 w-full`}
                            >
                              <h4 className="text-gray-600 dark:text-gray-300 font-semibold">
                                Size/Pattern
                              </h4>

                              <div className="">
                                <select
                                  name="size_id"
                                  value={x.size_id}
                                  className="focus:outline-none border border-[#A68F69] box-border px-2 py-3 text-base font-bold rounded focus:ring-2 ring-[#A68F69] w-full"
                                  onChange={(e) => handleInputChange(e, i)}
                                  disabled={moq?.product?.[0]?.varying_sizes === 1 && bid?.status === 1}
                                >
                                  <option value={""}>Select Size/Pattern</option>

                                  {product?.readable_sizes &&
                                    product?.readable_sizes.length > 0 &&
                                    product?.readable_sizes.map((size, i) => (
                                      <option
                                        key={i}
                                        value={size.id}
                                        selected={
                                          (size?.label === "None" ||
                                            size?.label === "none") &&
                                          product?.readable_sizes.length === 1
                                        }
                                      >
                                        {size?.label}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>

                            <div
                              className={`${product?.readable_colors &&
                                product?.readable_colors.length === 1 &&
                                (product?.readable_colors[0]?.label ===
                                  "None" ||
                                  product?.readable_colors[0]?.label ===
                                  "none")
                                ? "hidden"
                                : "block"
                                } md:space-y-2 w-full`}
                            >
                              <h4 className="text-gray-600 dark:text-gray-300 font-semibold">Color</h4>

                              <div className="grid grid-cols-5 gap-1">
                                <select
                                  name="color_id"
                                  value={x.color_id}
                                  className="col-span-3 focus:outline-none border border-[#A68F69] box-border px-2 py-3 text-base font-bold rounded focus:ring-2 ring-[#A68F69] w-full disabled:bg-slate-200"
                                  onChange={(e) => {
                                    handleInputChange(e, i);
                                  }}
                                >
                                  <option value={""}>Select Color</option>

                                  {product?.readable_colors &&
                                    product?.readable_colors.length > 0 &&
                                    product?.readable_colors.map((color, i) => (
                                      <option key={i} value={color.id}>
                                        {color?.label}
                                      </option>
                                    ))}
                                </select>

                                <div
                                  className="col-span-2 h-full w-full rounded shadow-sm border border-[#A68F69]"
                                  style={{
                                    backgroundColor: `${product?.readable_colors &&
                                      product?.readable_colors.find(
                                        (color) => color?.id === parseInt(x.color_id)
                                      )?.value
                                      }`,
                                  }}
                                ></div>
                              </div>
                            </div>

                            <div className="md:space-y-2">
                              <h4 className="text-gray-600 dark:text-gray-300 font-semibold">Quantity</h4>

                              <input
                                className="focus:outline-none border border-[#A68F69] box-border px-2 py-3 text-base font-bold rounded focus:ring-2 ring-[#A68F69] w-full"
                                type={"number"}
                                min={0}
                                name="quantity"
                                value={x.quantity}
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </div>
                          </div>

                          <div className="flex flex-row justify-start items-center md:items-end space-x-1 px-1 md:px-0 md:space-x-2 h-full">

                            {bidAttributes.length !== 1 && (
                              <button
                                className="bg-tangerine text-white p-2 rounded shadow-sm text-sm"
                                onClick={() => handleRemoveClick(i)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  />
                                </svg>
                              </button>
                            )}

                            {bidAttributes.length - 1 === i && (
                              <button
                                className="bg-tangerine text-white p-2 rounded shadow-sm text-sm"
                                onClick={() => handleAddClick()}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 4v16m8-8H4"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        </div>
                      ))}

                      <h1 className="text-[#A68F69] dark:text-gray-300 font-bold text-lg">
                        Shipping
                      </h1>
                      <span className="text-xs text-[#5B5B5B] dark:text-gray-300">
                        These are approximate costs based on the current shipping rates
                      </span>

                      <div className="gap-y-3 xl:gap-y-0 xl:gap-x-3 my-4 grid grid-cols-1 xl:grid-cols-2 mb-4">
                        <div
                          className="flex flex-row relative cursor-pointer bg-white rounded-xl"
                          onClick={() => setShipping("SEA")}
                        >
                          <div className="px-4 bg-green-500 text-white flex flex-col justify-center items-center rounded-l-xl">
                            <LazyLoadImage className="m-0 p-0" src="/img/ship.png" alt="ship" />
                          </div>

                          <div className="flex flex-col flex-1 px-2 py-3 border-[#A68F69] border-y-2 border-r-2 rounded-r-xl">
                            <h4 className="text-[#5B5B5B] text-sm mb-0 font-bold">Sea</h4>

                            {renderShippingFees(moq, product, "shipping_fee_sea")}
                          </div>

                          {shipping === "SEA" && (
                            <div className="absolute -top-2 -right-2 bg-[#A68F69] rounded-full text-white p-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M5 13l4 4L19 7"
                                />
                              </svg>
                            </div>
                          )}
                        </div>

                        <div
                          className="flex flex-row relative cursor-pointer bg-white rounded-xl"
                          onClick={() => setShipping("AIR")}
                        >
                          <div className="px-4 bg-blue-500 text-white flex flex-col justify-center items-center rounded-l-xl">
                            <LazyLoadImage className="m-0 p-0" src="/img/plane.png" alt="plane" />
                          </div>

                          <div className="flex flex-col flex-1 px-2 py-3 border-[#A68F69] border-y-2 border-r-2 rounded-r-xl">
                            <h4 className="text-[#5B5B5B] text-sm mb-0 font-bold">Air</h4>

                            {renderShippingFees(moq, product, "shipping_fee_air")}
                          </div>

                          {shipping === "AIR" && (
                            <div className="absolute -top-2 -right-2 bg-[#A68F69] rounded-full text-white p-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M5 13l4 4L19 7"
                                />
                              </svg>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex flex-col md:flex-row justify-end items-center md:py-10 space-y-3 md:space-y-0">
                        <button
                          disabled={loading}
                          className="w-full md:w-fit px-20 bg-tangerine text-white py-2 font-bold"
                          type="submit"
                        >
                          {loading ? "Editing Your Order..." : "Edit Order"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <RecommendedProducts />
    </Layout>
  );
}

const mapStateToProps = (state) => {
  return {
    categories: state.categories,

    moqs: state.moqs,

    bids: state.bids,

    products: state.products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { showBid, getProductById, cancelBid, updateBid, getMoqById },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
